import React, { FC, useContext, useMemo } from 'react'
import styled from '@emotion/styled'
import { useTranslation } from 'react-i18next'
import { ChatMobilePreviewDetailData } from './ChatMobilePreviewDetail'
import { ChatMobilePreviewDetails } from './ChatMobilePreviewDetails'
import { ApiChatPreviewTotalInfo } from '../../../api/chats/types/ApiChatPreview'
import { MoneyView } from '../../../common/components/MoneyView'
import { PreviewEditsContext } from '../../../features/preview-edits/model/PreviewEditsContext'
import { PreviewSkeleton } from '../../../features/preview-edits/ui/PreviewSkeleton'

const Details = styled(ChatMobilePreviewDetails)(({ theme }) => ({
  border: '1px solid ' + theme.colors.common.black,
}))

export const ChatMobilePreviewTotal: FC<{ totalInfo: ApiChatPreviewTotalInfo }> = ({ totalInfo }) => {
  const { t } = useTranslation()
  const { dirty } = useContext(PreviewEditsContext)

  const details: ChatMobilePreviewDetailData[] = useMemo(
    () => [
      {
        title: t('Summary of your quote'),
        value: null,
      },
      { title: t('Gross'), value: dirty ? <PreviewSkeleton /> : <MoneyView value={totalInfo.grossAmount} /> },
      {
        title: t('Base'),
        value: dirty ? <PreviewSkeleton /> : <MoneyView value={totalInfo.base} />,
      },
      {
        title: t('VAT'),
        value: dirty ? <PreviewSkeleton /> : totalInfo.vat,
      },
      { title: t('Taxes'), value: dirty ? <PreviewSkeleton /> : <MoneyView value={totalInfo.taxes} /> },
      {
        title: t('Total'),
        value: dirty ? <PreviewSkeleton /> : <MoneyView value={totalInfo.totalAmount} />,
      },
    ],
    [t, totalInfo, dirty],
  )

  return <Details details={details} />
}
